import React, { useState } from 'react';
import { Container, Typography, TextField, Button, Box, Paper, Alert, CircularProgress, Dialog, DialogContent, DialogTitle } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import apiService from '../components/ReasuableFuncations/api';
import { AppBar, Toolbar } from '@mui/material';
import { Link } from 'react-router-dom';


const UpdatePassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openLoadingDialog, setOpenLoadingDialog] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Check if passwords match
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setError(null);
    setSuccess(null);
    setLoading(true);
    setOpenLoadingDialog(true);

    try {
      const token = localStorage.getItem('tokenExpiration'); // Assume token is stored after clicking password reset link
      const response = await apiService.post('/api/updatePassword', { newPassword, token });

      if (response.status === 200) {
        setSuccess('Password updated successfully!');
        setTimeout(() => {
          navigate("/login");
        }, 1000); // Redirect to login page after 1 seconds
      } else {
        setError('Failed to update password. Please try again.');
      }
    } catch (error) {
      setError('An error occurred. Please try again later.');
    } finally {
      setLoading(false);
      setOpenLoadingDialog(false);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundImage: 'url(./l-img.jpg)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
         <AppBar position="static" sx={{ backgroundColor: 'transparent', boxShadow: 'none' }}>
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Box display="flex" alignItems="center">
            <img src="./logo.png" alt="COMESA Logo" style={{ maxWidth: '50px', marginRight: '16px' }} />
            <Typography variant="h6">Portal</Typography>
          </Box>
          <Button color="inherit" component={Link} to="/about">About</Button>
        </Toolbar>
      </AppBar>


      <Container maxWidth="sm" sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 4 }}>
        <Paper elevation={20} sx={{ p: 4, width: '100%' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography component="h1" variant="h5" sx={{ my: 2, fontWeight: 'bold' }}>Update Password</Typography>
            <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
              {error && <Alert severity="error">{error}</Alert>}
              {success && <Alert severity="success">{success}</Alert>}

              <TextField
                margin="normal"
                required
                fullWidth
                id="newPassword"
                label="New Password"
                name="newPassword"
                type="password"
                autoComplete="new-password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                id="confirmPassword"
                label="Confirm Password"
                name="confirmPassword"
                type="password"
                autoComplete="confirm-password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3 }}
                disabled={loading || newPassword === '' || confirmPassword === ''}
              >
                {loading ? <CircularProgress size={24} color="inherit" /> : 'Update Password'}
              </Button>
            </Box>
          </Box>
        </Paper>
      </Container>

      <Dialog open={openLoadingDialog} onClose={() => setOpenLoadingDialog(false)}>
        <DialogTitle>Updating Password</DialogTitle>
        <DialogContent sx={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress />
        </DialogContent>
      </Dialog>

      <Box component="footer" sx={{ backgroundColor: '#333', color: '#fff', padding: '10px', textAlign: 'center' }}>
        <Typography variant="body2">©️ {new Date().getFullYear()} EA-SA-IO ICT M&E Portal. All rights reserved.</Typography>
      </Box>
    </Box>
  );
};

export default UpdatePassword;
